export default __webpack_public_path__ + "static/media/logo-white.eb710fe0.svg";